module.exports = __webpack_public_path__ + "img/message.dac4f0c7.svg";